module.exports = __webpack_public_path__ + "static/media/icono_solista.f09861b4.svg";